export default {"src":"/_next/static/media/dhl.5bee14d5.svg","height":512,"width":512};